import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { FDContentContainer, FDStack } from '@facet-wealth/design';
import ScenarioSelectionRedefinedStepContentHeader
  from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedWrapperTemplate/ScenarioSelectionRedefinedStepLayoutWithContentHeader/ScenarioSelectionRedefinedStepContentHeader';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import useMobileLayout from 'Hooks/useMobileLayout';
import { LottieLoadingLayout } from 'Organisms/LottieControl/LottieLoadingLayout';
import {
  ScenarioSelectionRedefinedTheYearAheadGoalStrategiesDetailsContent,
} from './Content';


export const ScenarioSelectionRedefinedTheYearAheadGoalStrategiesDetailsStepLayout = () => {
  const { resource } = useMetaLayoutContext();

  const isMobile = useMobileLayout();
  return (
    <FDContentContainer maxWidth="lg" minHeight={'100dvh'} flexGrow={1}>
      <LottieLoadingLayout>
        <FDStack direction="column" spacing={5} paddingY={isMobile ? 0 : 2} alignItems="center">
          <ScenarioSelectionRedefinedStepContentHeader resource={resource} />
          <ScenarioSelectionRedefinedTheYearAheadGoalStrategiesDetailsContent />
          <MetaControlField attr={'disclaimerText'} />
        </FDStack>
      </LottieLoadingLayout>
    </FDContentContainer>);
};

ScenarioSelectionRedefinedTheYearAheadGoalStrategiesDetailsStepLayout.propTypes = {
};
